import { getImagesByQuery } from './js/pixabay-api.js';
import { createGallery, clearGallery, showLoader, hideLoader } from './js/render-functions.js';
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const form = document.querySelector('#search-form');

form.addEventListener('submit', (event) => {
    event.preventDefault();
    
    const query = event.currentTarget.elements['search-text'].value.trim();

    if (query === "") {
        iziToast.warning({ message: "Please enter a search term!" });
        return;
    }

    clearGallery();
    showLoader();

    getImagesByQuery(query)
        .then(data => {
            if (data.hits.length === 0) {
                iziToast.error({
                    message: "Sorry, there are no images matching your search query. Please try again!",
                    position: 'topRight'
                });
                return;
            }
            createGallery(data.hits);
        })
        .catch(error => {
            console.error(error);
            iziToast.error({ message: "Something went wrong. Please try again later." });
        })
        .finally(() => {
            hideLoader();
            form.reset();
        });
});

